import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconDoubleCheckmark1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconDoubleCheckmark1"><Path d="M22.2871 4.52539L11.9746 20.5371L10.7129 19.7246L21.0254 3.71289L22.2871 4.52539Z" fill="currentColor"/><Path d="M18.2861 4.52441L7.99512 20.5332L1.69629 12.6592L2.86719 11.7227L7.8623 17.9658L17.0244 3.71387L18.2861 4.52441Z" fill="currentColor"/></CentralIconBase>;
});

export default IconDoubleCheckmark1;
